import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col, Table, Modal, Button, Form, Spinner } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { ORG_CREATE, ORG_DETAIL, ORG_LIST, ORG_UPDATE, fetchData } from '../../components/Service';
import { displayError } from '../../components/Helper';

const Organization = () => {
    const [listLoader, setListLoader] = useState(false)
    const [tinyLoader, setTinyLoader] = useState(false)

    const [list, setList] = useState([])
    const [data, setData] = useState()
    const [Modal1, setModal1] = useState(false);
    const [Modal2, setModal2] = useState(false);

    const handleClose1 = () => setModal1(false);
    const handleShow1 = () => setModal1(true);
    const handleClose2 = () => setModal2(false);
    const handleShow2 = () => setModal2(true);

    const getList = (e) => {
        setListLoader(true);

        fetchData(ORG_LIST, 'GET', "", true, false, (res) => {
            setListLoader(false);
            if (res.status === "success") {
                setList(res.records)
            } else {
            }
        });
    }

    const saveData = (e, type) => {
        let formData = new FormData(document.getElementById(type + '-organization'));
        
        let payload = {
            id: data && data.id,
            name: formData.get("name"),
        }

        if(type === "update") {
            payload = {
                ...payload,
                status: formData.get("status"),
            }
        }

        setTinyLoader(type)

        fetchData(type === "update" ? ORG_UPDATE : ORG_CREATE, 'POST', payload, true, false, (res) => {
            setTinyLoader(false);

            if (res.status === "success") {
                handleClose1()
                handleClose2()
                getList()
            } else {
                displayError(res.errors)
            }
        });
    }

    const getUser = (id) => {
        setTinyLoader("edit");

        fetchData(ORG_DETAIL + "/" + id, 'GET', "", true, false, (res) => {
            setTinyLoader(false);
            if (res.status === "success") {
                setData(res.records)
                handleShow2()
            } else {
                // displayError(res.errors)
            }
        });
    }

    useEffect(() => {
        getList()
    }, [])

    return (
        <>
        <div className="dashboard-content-block">
            <div className="dashbaord-heading">
                Organizations
            </div>
            <div className="user-table-block">
                <div className="create-user-block">
                    <Button variant="primary" onClick={handleShow1}>Create Organization</Button>
                </div>
                <Table responsive bordered hover>
                    <thead>
                        <tr>
                            <th>Organization Id</th>
                            <th>Organization Name</th>
                            <th>Organization Status</th>
                            <th width="100px" className="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list && list.length ? list.map((item, i) => (
                            <tr key={item.id}>
                                <td className="text-center">{item.id}</td>
                                <td>{item.name}</td>
                                <td><span className={`status-block ${item.status}`}>{item.status == "active" ? "ACTIVE" : "PAUSE"}</span></td>
                                <td className="text-center">
                                    <Button variant="edit" onClick={(e) => getUser(item.id)}><FontAwesomeIcon icon="fa-solid fa-pencil" /></Button>
                                </td>
                            </tr>
                        )) : <tr><td colSpan="6" className='text-center text-danger'>No User Found</td></tr>}
                    </tbody>
                </Table>
            </div>
        </div>

        <Modal centered show={Modal1} onHide={handleClose1} className="custom-dashboard-model" key="1">
            <Modal.Header closeButton>
            <Modal.Title>Create Organization</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id="create-organization">
                    <Row>
                        <Col lg={12}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Name *</Form.Label>
                                <Form.Control type="text" name="name"/>
                                <span id="form-error-name" className='form-input-error'></span>
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="dash-buttons-block">
                        <Button variant="primary" onClick={(e) => saveData(e, 'create')} disabled={tinyLoader === "create"}>{ tinyLoader === "create" && <Spinner animation="grow" size="sm" /> } Create Organization</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>

        <Modal centered show={Modal2} onHide={handleClose2} className="custom-dashboard-model" key="2">
            <Modal.Header closeButton>
            <Modal.Title>Edit Organization</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id="update-organization">
                    <Row>
                        <Col lg={9}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Name *</Form.Label>
                                <Form.Control type="text" name="name" defaultValue={data && data.name}/>
                                <span id="form-error-name" className='form-input-error'></span>
                            </Form.Group>
                        </Col>
                        <Col lg={3}>
                            <Form.Group className="form-group">
                                <Form.Label>Select Status</Form.Label>
                                <Form.Select name="status">
                                    <option value="active" selected={data?.status === "active"}>
                                        Active
                                    </option>
                                    <option value="pause" selected={data?.status === "pause"}>
                                        Pause
                                    </option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="dash-buttons-block">
                        <Button variant="primary" onClick={(e) => saveData(e, 'update')} disabled={tinyLoader === "update"}>{ tinyLoader === "update" && <Spinner animation="grow" size="sm" /> } Update Organization</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
        </>
    );
};

export default Organization;
